import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import {resourceFactory} from '../resourceFactory';
import defineRulesFor from '../config/rules';
import axios from 'axios';

axios.defaults.withCredentials = true;

const auth = resourceFactory.get('auth');


Vue.use(VueRouter);

// configure router
const router = new VueRouter({
    mode: 'history',
    routes, // short for routes: routes
    linkActiveClass: 'active',
    scrollBehavior: (to, from, savedPosition) => {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return {selector: to.hash};
        }
        return {x: 0, y: 0};
    }
});

router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.auth)) {
        // Check if user is authenticated
        try {
            let response = await axios.get(auth.user());
            await Vue.prototype.$ability.update(defineRulesFor(response.data));
            Vue.prototype.$user = response.data;
            next();
        } catch (error) {
            next({
                path: '/login',
                params: {nextUrl: to.fullPath}
            });
        }
    } else if (to.matched.some(record => record.meta.guest)) {
        // Check if user is authenticated and is trying to reach login/register pages etc..
        try {
            await axios.get(auth.user());
            next({
                path: '/dashboard',
                params: {nextUrl: to.fullPath}
            });
        } catch (error) {
            next()
        }
    }

    next();
});


export default router;
